import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action";
import { Qualifier } from "../../internal/qualifier/Qualifier";
/**
 * @description Simulates the way an image would appear to someone with the specified color blind condition
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var SimulateColorBlindEffectAction = /*#__PURE__*/function (_Action) {
  _inherits(SimulateColorBlindEffectAction, _Action);

  var _super = _createSuper(SimulateColorBlindEffectAction);

  function SimulateColorBlindEffectAction() {
    var _this;

    _classCallCheck(this, SimulateColorBlindEffectAction);

    _this = _super.call(this);

    _this.addQualifier(new Qualifier('e', "simulate_colorblind"));

    return _this;
  }

  _createClass(SimulateColorBlindEffectAction, [{
    key: "setQualifier",
    value: function setQualifier(val) {
      var strToAppend = ":".concat(val);

      if (val) {
        this.addQualifier(new Qualifier('e', "simulate_colorblind".concat(strToAppend)));
      }

      return this;
    }
    /**
     * @description Sets the color blind condition to simulate.
     * @param {Qualifiers.simulateColorBlindValues | string} cond
     * @return {this}
     */

  }, {
    key: "condition",
    value: function condition(cond) {
      return this.setQualifier(cond);
    }
  }]);

  return SimulateColorBlindEffectAction;
}(Action);

export { SimulateColorBlindEffectAction };